import { CheckOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Form, message, Select, Tag } from "antd"
import { useState } from "react"
import { useGetRoles } from "../../../../apis/Roles"
import { usePatchUserData } from "../../../../apis/user"
import { useAuthContext } from "../../../../context/AuthContext"
import { UserRoles, UserRoleTags } from "../../../../types/user"
import { RowContent } from "../../../Utils/RowContent"

type Props = {
  roleTags: UserRoleTags[]
  roles: UserRoles[]
  id: string
}

type FormValues = {
  roles: UserRoles[]
}

function arraysEqual(arr1: any[], arr2: any[]): boolean {
  if (arr1.length !== arr2.length) return false

  arr1.sort()
  arr2.sort()

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  return true
}

export default function UserRolesWidget({ roles, id, roleTags }: Props) {
  const { token, env } = useAuthContext()
  const [isEditing, setIsEditing] = useState(false)
  const { mutateAsync: updateUserRoles } = usePatchUserData(env)
  const [form] = Form.useForm<FormValues>()

  const userRoles = useGetRoles({
    env,
    token: token[env],
    type: "roles/system",
    enabled: isEditing,
  })

  const onSubmit = async (values: FormValues) => {
    try {
      if (values.roles && !arraysEqual(values.roles, roles)) {
        await updateUserRoles({
          payload: {
            id,
            roles: values.roles,
            roleTags,
          },
          env,
          token: token[env] as string,
        })
        message.success("System Roles Updated")
      }

      return
    } catch (error) {
      message.error("Error Updating System Roles")
      return
    } finally {
      setIsEditing(false)
    }
  }

  return (
    <RowContent
      name="System Roles"
      content={
        isEditing ? (
          <Form
            form={form}
            onFinish={onSubmit}
            style={{ display: "flex", gap: 10, alignItems: "center" }}
          >
            <Form.Item
              name="roles"
              initialValue={roles}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: 0,
              }}
            >
              <Select
                loading={userRoles.isLoading}
                style={{ width: "200px" }}
                mode="multiple"
                placeholder="Select roles"
                options={userRoles?.data?.map((role, index) => ({
                  label: role.name,
                  value: role.id,
                }))}
              />
            </Form.Item>
            <Button size="small" type="primary" htmlType="submit">
              <CheckOutlined />
            </Button>
          </Form>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            {roles.map((role, index) => (
              <Tag key={index}>{role}</Tag>
            ))}
            <Button size="small" onClick={() => setIsEditing(true)}>
              <EditOutlined />
            </Button>
          </div>
        )
      }
    />
  )
}
